import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import Main from './components/main';
import appStore from './reducers/index';
import fetchMiddleware from './reducers/middlewares/fetchMiddleware';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faPlusCircle, faAngleLeft, faAngleRight, faPlusSquare, faSignOutAlt, faBars, faComments, faMobileAlt, faMusic, faNetworkWired, faCookie } from '@fortawesome/free-solid-svg-icons';

library.add(faUser, faPlusCircle, faAngleLeft, faAngleRight, faPlusSquare, faSignOutAlt, faBars, faComments, faMobileAlt, faMusic, faNetworkWired, faCookie);

const store = createStore(appStore, applyMiddleware(fetchMiddleware));

class App extends Component {

  render () {
    return (
      <div style={{ height: 'inherit' }}>
        <Provider store={store}>
          <Main />
        </Provider>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js